import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import {REALM_HEADER} from "@next/utils"
import State from "../../ducks/state"

export const mapStateToProps = (state: State) => {
    const realm = (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string

    return {
        realm,
        variant: state.settings.variant,
        iconsVersionPath: state.settings.iconsVersionPath,
        templating: state.template,
    }
}

export default connect(mapStateToProps)
